export const SET_ENTITY_LIST = 'boilderplate/GSTR2X/SET_ENTITY_LIST';
export const DEFAULT_ENTITY = 'boilderplate/GSTR2X/DEFAULT_ENTITY'
export const PROFILE_DATA = 'boilderplate/GSTR2X/PROFILE_DATA';
export const STORE_GSTIN_GSTR2X = 'boilderplate/GSTR2X/STORE_GSTIN_GSTR2X';
export const LOADER_STATUS = 'boilerplate/GSTR2X/LOADER_STATUS';
export const STORE_PERIOD = 'boilerplate/GSTR2X/STORE_PERIOD';
export const FILE_RETURN_PERIOD = 'boilerplate/GSTR2X/FILE_RETURN_PERIOD';